import styled from "styled-components"

import { maxWidth, when } from "utils"

import Icon from "icons"
import HeroContent from "components/hero/content"

export const Wrapper = styled.div`
  padding: 6rem 8.5rem;

  ${maxWidth.mobile`
    padding: 3rem 2rem;
  `}
`

export const StyledHeroContent = styled(HeroContent)`
  max-width: 60rem;
  margin: 0 auto;
  display: block;
  text-align: center;

  ${maxWidth.mobile`
    text-align: left !important;
  `}

  h3 {
    margin-bottom: 3rem;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.62rem;
    letter-spacing: 0.2rem;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.primaryOrange};
  }

  h1 {
    font-size: 3.2rem;
    font-weight: 400;
    line-height: 4.32rem;

    ${maxWidth.mobile`
      font-size: 2.4rem;
      line-height: 3.24rem;
    `}
  }

  p {
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.496rem;
  }
`

export const List = styled.div`
  margin: 3rem 0;
  display: flex;

  ${maxWidth.mobile`
    flex-direction: column;
  `}
`

export const ItemContainer = styled.div`
  position: relative;
  margin-right: 2rem;
  padding: 3.6rem 2rem;
  border: 0.1rem solid rgba(34, 34, 34, 0.2);
  flex: 1;
  transition: border-color 0.1s linear;
  cursor: pointer;

  &:last-of-type {
    margin-right: 0;
  }

  ${maxWidth.mobile`
    margin-right: 0;
    margin-bottom: 2rem;
    padding: 2rem;

    &:last-of-type {
      margin-bottom: 0;
    }
  `}

  ${when("isSelected")`
    border-color: ${({ theme }) => theme.colors.primaryOrange};
  `}
`

export const ItemHeader = styled.div`
  ${maxWidth.mobile`
    display: flex;
  `}
`

export const ItemLogo = styled.img`
  width: 4.8rem;
  height: 4.8rem;
`

export const ItemTitleAndSubtitle = styled.div`
  ${maxWidth.mobile`
    margin-left: 2rem;
  `}
`

export const ItemTitle = styled.h2`
  margin-top: 2rem;
  margin-bottom: 0.6rem;
  font-size: 2.4rem;
  font-weight: 400;
  line-height: 3.24rem;

  ${maxWidth.mobile`
    margin-top: 0;
  `}
`

export const ItemSubtitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  line-height: 2.184rem;
`

export const ItemSubtitleIcon = styled(Icon)`
  margin-right: 1rem;
  color: #222;
`

export const DesktopWrapper = styled.div`
  ${maxWidth.mobile`
    display: none;
  `}
`

export const MobileWrapper = styled.div`
  display: none;

  ${maxWidth.mobile`
    display: block;
  `}
`

export const ItemBody = styled.p`
  margin-top: 2rem;
  font-size: 1.6rem;
  line-height: 2.496rem;
`

export const MoreLessButton = styled.button`
  font-size: 1.6rem;
  line-height: 2.496rem;
  text-decoration: underline;
`

export const CheckIconWrapper = styled.div`
  position: absolute;
  top: -1.2rem;
  right: -1.2rem;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.primaryOrange};
  opacity: 0;
  transition: opacity 0.1s linear;

  ${when("isSelected")`
    opacity: 1;
  `}
`

export const CheckIcon = styled(Icon)`
  color: #fff;
`
